import React from 'react'

export default ({over = false, visible = false}) => {
    return over ? <div className={`loading-overlay ${visible ? "active" : ""}`}><div className="loading"></div></div> : <div className="loading"></div>
}